<ng-container [ngSwitch]="field.controlType" [formGroup]="form">
  <ng-container *ngIf="!field.hidden">
    <div class="office-text" *ngIf="field.forOfficeUseOnly">
      {{ 'FRONTEND.STORE.ORDER_FORM.HIDDEN_FROM_END_USERS' | translate }}:
    </div>
    <div class="office-text" *ngIf="field.officeEditableOnly">
      {{ 'FRONTEND.STORE.ORDER_FORM.OFFICE_EDITABLE_ONLY' | translate }}:
    </div>

    <ng-container *ngSwitchCase="'dropdown'">
      <ng-container *ngIf="!field.allowMultiples">
        <div class="display">
          <glxy-form-field>
            <glxy-label>{{ field.label | translate }}{{ field.required ? '*' : '' }}</glxy-label>
            <mat-select matInput [formControlName]="field.id" [id]="field.id">
              <mat-option *ngFor="let option of field.options" [value]="option.value">
                {{ option.label }}
              </mat-option>
            </mat-select>
            <glxy-hint position="below" *ngIf="field.description">
              {{ field.description }}
            </glxy-hint>
          </glxy-form-field>
        </div>
        <div class="print">
          <div class="label">{{ field.label | translate }}:</div>
          <div class="answer">{{ dropdownAnswer() }}</div>
        </div>
      </ng-container>
      <ng-container *ngIf="field.allowMultiples">
        <div class="display">
          <forms-input-tags
            [id]="field.id"
            [formControlName]="field.id"
            label="{{ field.label | translate }}{{ field.required ? ' *' : '' }}"
            [hint]="field.description"
            [required]="field.required"
            [options]="field.options"
            [allowDuplicates]="field.allowDuplicates"
            [maxFields]="field.maxChoices"
          ></forms-input-tags>
        </div>
        <div class="print">
          <div class="label">{{ field.label | translate }}:</div>
          <div class="answer">{{ multidropdownAnswer() }}</div>
        </div>
      </ng-container>
    </ng-container>

    <ng-container *ngSwitchCase="'textbox'">
      <div class="display">
        <glxy-form-field [prefixText]="field.prefix" [suffixText]="field.suffix">
          <glxy-label>{{ field.label | translate }}{{ field.required ? ' *' : '' }}</glxy-label>
          <input
            matInput
            [type]="field.textboxType"
            [id]="field.id"
            [formControlName]="field.id"
            [pattern]="field.regexValidator || ''"
            [readonly]="field.displayOnly"
            [ngClass]="{ 'display-only': field.displayOnly }"
          />
          <glxy-hint position="below" *ngIf="field.description">
            {{ field.description }}
          </glxy-hint>
          <glxy-error *ngIf="form.controls[field.id].hasError('pattern')">
            {{ field.regexErrorMessage }}
          </glxy-error>
        </glxy-form-field>
      </div>
      <div class="print">
        <div class="label">{{ field.label | translate }}:</div>
        <div class="answer">{{ getValue() }}</div>
      </div>
    </ng-container>

    <ng-container *ngSwitchCase="'checkbox'">
      <div class="display">
        <glxy-form-field>
          <mat-checkbox [formControlName]="field.id" [id]="field.id" ngControlDefault>
            {{ field.label | translate }}{{ field.required ? ' *' : '' }}
            <extended *ngIf="field.description">
              {{ field.description }}
            </extended>
          </mat-checkbox>
          <glxy-error *ngIf="showCheckboxError(field.id)" class="checkboxError">
            {{ 'FRONTEND.STORE.REQUIRED' | translate }}
          </glxy-error>
        </glxy-form-field>
      </div>
      <div class="print">
        <div class="label">{{ field.label | translate }}:</div>
        <div class="answer">{{ checkboxAnswer() }}</div>
      </div>
    </ng-container>

    <ng-container *ngSwitchCase="'textarea'">
      <span class="display">
        <glxy-form-field>
          <glxy-label>{{ field.label | translate }}{{ field.required ? ' *' : '' }}</glxy-label>
          <textarea matInput [formControlName]="field.id" [id]="field.id" cdkTextareaAutosize></textarea>
          <glxy-hint position="below" *ngIf="field.description">
            {{ field.description }}
          </glxy-hint>
        </glxy-form-field>
      </span>
      <div class="print">
        <div class="label">{{ field.label | translate }}:</div>
        <div class="answer textarea-answer">{{ getValue() }}</div>
      </div>
    </ng-container>

    <ng-container *ngSwitchCase="'file'">
      <span class="display" *ngIf="this.form.controls[this.field.id].value as uploadedFiles">
        <glxy-form-field
          [required]="field.required"
          [forceRequiredError]="
            this.form.controls[this.field.id].touched && (!uploadedFiles.length || uploadedFiles?.length === 0)
          "
        >
          <glxy-label>{{ field.label | translate }}{{ field.required ? ' *' : '' }}</glxy-label>
          <glxy-hint position="below" *ngIf="field.description">
            {{ field.description }}
          </glxy-hint>
          <ng-container *ngIf="!field.disabled">
            <glxy-uploader
              #glxyUploader
              [uploadUrl]="field.uploadUrl"
              [maxFiles]="field.numFiles"
              [maxFileSize]="MAX_FILE_SIZE"
              (fileUploaded)="onUpload($event)"
              [hasError]="
                this.form.controls[this.field.id].touched &&
                (!uploadedFiles.length || uploadedFiles?.length === 0) &&
                field.required
              "
            ></glxy-uploader>
            <glxy-uploader-list [files]="uploadedFiles || []" (fileDeleted)="deleteFile($event)"></glxy-uploader-list>
          </ng-container>
          <ng-container *ngIf="field.disabled">
            <ng-container *ngIf="!uploadedFiles.length">&mdash;</ng-container>
            <ng-container *ngIf="uploadedFiles.length">
              <ul class="file-static-list">
                <li *ngFor="let file of uploadedFiles">
                  <a href="{{ file.url }}" target="_blank">{{ file.name }}</a>
                </li>
              </ul>
            </ng-container>
          </ng-container>
        </glxy-form-field>
      </span>
      <div class="print">
        <div class="label">{{ field.label | translate }}:</div>
        <div class="answer">{{ fileUploadAnswer() }}</div>
      </div>
    </ng-container>

    <ng-container *ngSwitchCase="'vbcuser'">
      <div class="display">
        <glxy-form-field>
          <glxy-label>{{ field.label | translate }}{{ field.required ? ' *' : '' }}</glxy-label>
          <mat-select matInput [formControlName]="field.id" [id]="field.id">
            <mat-option *ngFor="let option of field.options" [value]="option.value" [disabled]="option.disabled">
              {{ option.label | translate }}
            </mat-option>
          </mat-select>
          <glxy-hint position="below" *ngIf="field.description">
            {{ field.description }}
          </glxy-hint>
        </glxy-form-field>
      </div>
      <div class="print">
        <div class="label">{{ field.label | translate }}:</div>
        <div class="answer">{{ dropdownAnswer() }}</div>
      </div>
    </ng-container>
  </ng-container>
</ng-container>
